export default {"src":"/_next/static/media/mln.4b0520a8.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};